import { render } from "./ConfTravelNotifiche.vue?vue&type=template&id=49a55e48"
import script from "./ConfTravelNotifiche.vue?vue&type=script&lang=js"
export * from "./ConfTravelNotifiche.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__